import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson } from '../service/serviceUtil';

class QuitteQuestionnaire extends Component {
    constructor(props) {
        super(props);

        const types =  ['defaut', 'complete', 'elimine', 'interrompu', 'quota', 'inactif', 'reacces', 'panic'];

        this.state = {
            langueCourante: 'FR', 
            mounted: false, 
            config: {},
            type: types.includes(this.props.action) ? this.props.action : 'defaut',
            enquete: this.props.suffixe
        };
    }

    get labels() {
        return chainesLocales['QuitteQuestionnaire'][this.state.langueCourante];
    }

    componentDidMount() {
        console.info("quitte action " + this.state.type);

        Promise.all([getJson('collecteLangue', {suffixe: this.state.enquete}), getJson('collecteParameters', {suffixe: this.state.enquete}), getJson('detruireSession')]).then(([langue, params, retour]) => {
            if (retour === true) {
                console.info("session detruite");
            } else {
                console.error("Erreur API detruire session");
            }

            this.setState({langueCourante: langue || 'FR', mounted: true, config: params});
        }).catch((err) => {
            console.error("Erreur API quitte questionnaire: " + err);

            this.setState({mounted: true});
        });
    }

    render() {
        if (this.state.mounted) {
            const siteISQ = "https://statistique.quebec.ca/" + (this.state.langueCourante === "FR" ? "fr" : "en");
            const siteGoogle = "https://www.google.ca";

            const paramMsg = {
                defaut: 'M_DECONNEX_DEFT' ,
                complete: 'M_DECONNEX_COMPL', 
                elimine: 'M_DECONNEX_ELIM', 
                interrompu: 'M_DECONNEX_INTER', 
                quota: 'M_DECONNEX_QAF', 
                inactif: 'M_DECONNEX_INACT', 
                reacces: 'M_DECONNEX_REACC'
            }

            if (["defaut", "complete"].includes(this.state.type)) {
                setTimeout(() => window.location.replace(siteISQ), 5000);
            } else if (this.state.type === "panic") {
                window.location.replace(siteGoogle);
            }

            return (
                <div dangerouslySetInnerHTML={{ __html: this.state.config[paramMsg[this.state.type] + '_' + this.state.langueCourante] || this.labels[this.state.type] }} />
            );
        } else {
            return (
                <>&nbsp;<div className="loading-spinner-mini" /></>
            );
        }
    }
}

QuitteQuestionnaire.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired
}

QuitteQuestionnaire.defaultProps = {
    lang: "FR"
}

export default QuitteQuestionnaire